import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Container, Menu, Sidebar} from 'semantic-ui-react';
import AddIcon from '../../shared/add-icon';
import {useSelector} from 'react-redux';
import {AUTHENTICATED} from '../../../redux/constants';

function SidebarContainer(props) {
  const {visible, setVisible} = props;
  const isAuthenticated = useSelector(state => state.auth.status === AUTHENTICATED);

  return (
    <Sidebar.Pushable>
      <Sidebar
        inverted
        as={Menu}
        animation='overlay'
        icon='labeled'
        onHide={setVisible.bind(null, false)}
        vertical
        visible={visible}
        width='thin'
      >
        <Menu.Item as={Link} to='/profile' icon='home' content='خانه'/>

        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/homeworks'
            content='تکالیف'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/voices'
            content='توضیحات صوتی'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/student-courses'
            content='لیست کورس‌ها'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/reports'
            content='گزارش‌ها'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/report'
            content='ثبت گزارش'
            icon={<AddIcon name='clipboard check' className='icon'/>}
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/exam-reports'
            content='لیست گزارش آزمون‌ها'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/exam-report'
            content='ثبت گزارش آزمون'
            // icon={<AddIcon name='clipboard check' className='icon'/>}
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/charts'
            content='عملکرد'
            icon='chart line'
          />
        )}
        {isAuthenticated && (
          <Menu.Item
            as={Link}
            to='/consult-packages'
            content='خرید بسته مشاوره'
            icon='cart plus'
          />
        )}
        <Menu.Item as={Link} to='/contact-us' content='ارتباط با ما'/>
        <Menu.Item as={Link} to='/about-us' content='درباره ما'/>
        <Menu.Item as={Link} to='/complaints-registration' content='ثبت شکایات'/>
        <Menu.Item as={Link} to='/terms-and-conditions' content='قوانین و مقررات'/>
      </Sidebar>
      <Sidebar.Pusher as={Container} content={props.children}/>
    </Sidebar.Pushable>
  );
}

SidebarContainer.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default SidebarContainer;
